import { PrerenderConfig } from '@stencil/core';
export const config: PrerenderConfig = {
  hydrateOptions() {
    return {
      prettyHtml: true,
      minifyScriptElements: false,
    };
  },
  async afterHydrate(document) {
    const insertHeader = document.createElement('div');
    insertHeader.innerHTML = `
      This is a test
    `;

    document.body.innerHTML = '<p>Test</p>';

    return document;
  },
};
